import React, { useState, useEffect } from "react";
import '../components/world.css'
import AddIcon from '@mui/icons-material/Add';
import { SocialIcon } from 'react-social-icons'

const DunbaHome = () => {




    const socials = [{ site: "soundcloud", url: "https://soundcloud.com/dunba", icon: "white" }, { site: "instagram", url: "https://instagram.com/dunbatopaz", icon: "white" }, { site: "twitter", url: "https://twitter.com/dunbatopaz", icon: "white" }, { site: "email", url: "mailto:hello@dunba.world", icon: "white" }]
    return (
        <div className='flexcontainer'>
            <div className="nameandtitle">
                <h1 id='dunba'>DUNBA</h1>
                <p id='producer'> Producer | DJ</p>
            </div>
            <div className='icon-row'>
                {socials.map((social, index) => (<SocialIcon label={socials.site} bgColor="white" fgColor="black" network={social.site} url={social.url} />))}
            </div>
            <br />

        </div>

    )
}


export default DunbaHome